import Page from "../../components/Page";

export default function About() {
  return <Page title="A propos">Test </Page>;
}
